import { Typography } from '@scale/scaleui';
import { Icon } from '@scale/scaleui-radix';
import { Link } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type HeaderMenuCardProps = {
  shortTitle: string;
  to: string;
  icon: IconDefinition;
};

export function HeaderMenuCard({ shortTitle, icon, to }: HeaderMenuCardProps) {
  return (
    <Link
      className="shadow-none rounded-lg cursor-pointer border border-neutral-200 hover:border hover:border-primary-300 hover:shadow-primary-300"
      to={to}
    >
      <div className="flex flex-col gap-2 items-center justify-center p-5">
        <Icon
          icon={icon}
          size="2"
          color="accent"
          label={shortTitle}
          className="w-8 h-8 text-[#6A5DF9]"
        />
        <Typography.Overline3>{shortTitle}</Typography.Overline3>
      </div>
    </Link>
  );
}
